/**
 * @example
 * <div dangerouslySetInnerHTML={rawMarkup('<b>text</b>')} />
 */
export function rawMarkup(text) {
  return {
    __html: text
  };
}